import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconComponent, MainSelectComponent } from '@bilancio/ui';
import { OutsideModule } from 'src/app/utils/outside-click/outside.module';
import { ChangeOfficeComponent } from './change-office.component';

@NgModule({
    imports: [CommonModule, IconComponent, MainSelectComponent, OutsideModule],
    exports: [ChangeOfficeComponent],
    declarations: [ChangeOfficeComponent]
})
export class ChangeOfficeModule {}
